import { FormattedEvent } from '@eventbrite/event-renderer';
import {
    EventInteraction,
    EventInteractionContext,
} from '@eventbrite/event-tracker';
import { getFormattedTagsWithType } from '../../../utils/categories';
import { getBaseTrackingContext } from '../../../utils/tracking';

const CATEGORY_BROWSE_PLACEMENT = 'home_category';

export function aggregateContext({
    bucketKey,
    bucketPosition,
    events = [],
    event,
    eventSearch,
    userId,
    locale,
    sessionId,
    guestId,
}: Omit<EventInteraction, 'action'> & {
    bucketKey?: string;
    bucketPosition?: string;
    events: FormattedEvent[];
    eventSearch: any;
    userId?: string;
    locale?: string;
    sessionId?: string;
    guestId?: string;
}): EventInteractionContext {
    const baseTrackingContext = getBaseTrackingContext({
        event,
        events,
        userId,
        locale,
        guestId,
        sessionId,
    });

    return {
        ...baseTrackingContext,
        place: {
            name: CATEGORY_BROWSE_PLACEMENT,
            page: 1,
            context: {
                date_filter: eventSearch.dates || null,
                query_terms: eventSearch.q || null,
                is_online: !!eventSearch.online_events_only,
                place_id: Array.isArray(eventSearch.places)
                    ? eventSearch.places[0]
                    : null,
                latitude: null,
                longitude: null,
                tags: getFormattedTagsWithType(
                    (event as FormattedEvent).tags || [],
                ),
            },
            subInterface: {
                name: bucketKey,
                position: bucketPosition,
            },
            ...baseTrackingContext.place,
        },
    };
}
